// extracted by mini-css-extract-plugin
export default {"tablet":"(min-width: 768px)","autosizer":"s","item-wrapper":"t","itemWrapper":"t"};